module.exports = __webpack_public_path__ + "static/media/logo.6841730f.svg";